import React, { useState, useCallback } from 'react'
import Grid from '@material-ui/core/Grid'
import PropTypes from 'prop-types'
import SydButton from '../../../../../../../commonDesign/Button'
import SydModalActions from '../../../../../../../commonDesign/SydModal/SydModalActions'
import SydLabel from '../../../../../../../commonDesign/SydLabel'
import SydInput from '../../../../../../../commonDesign/SydInput'
import DqlEditor from '../DqlEditor'
import { useParseBlueprintFromDql } from '../../../../../../../../api/denali'
import { decipherError } from '../../../../../../../../utils/decipherError'

function AddPurposeForm ({ onCancel, onComplete }) {
  const [purposeCode, setPurposeCode] = useState('')
  const [displayName, setDisplayName] = useState('')
  const [dql, setDql] = useState('')
  const [parsedStructure, setParsedStructure] = useState(null)
  const [error, setError] = useState(null)

  const { mutateAsync: parseDql, isLoading: parsing } = useParseBlueprintFromDql()

  const handleParse = useCallback(async () => {
    if (!dql.trim() || !purposeCode.trim() || !displayName.trim()) return

    try {
      setError(null)
      const result = await parseDql({
        dql: dql.trim(),
        purposeCode: purposeCode.trim(),
        displayName: displayName.trim()
      })
      setParsedStructure(result)
    } catch (err) {
      setError(decipherError(err))
      setParsedStructure(null)
    }
  }, [dql, purposeCode, displayName, parseDql])

  const handleAdd = useCallback(() => {
    if (parsedStructure) {
      onComplete(parsedStructure)
    }
  }, [parsedStructure, onComplete])

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <SydLabel required label='Purpose Code' helperText='Lowercase, numbers, hyphens (e.g., summary, detailed)'>
          <SydInput
            value={purposeCode}
            onChange={(e) => setPurposeCode(e.target.value)}
            placeholder='summary'
          />
        </SydLabel>
      </Grid>

      <Grid item xs={12} md={6}>
        <SydLabel required label='Display Name' helperText='Human-readable name'>
          <SydInput
            value={displayName}
            onChange={(e) => setDisplayName(e.target.value)}
            placeholder='Summary View'
          />
        </SydLabel>
      </Grid>

      <Grid item xs={12}>
        <SydLabel required label='DQL Query'>
          <DqlEditor name='add-purpose-dql' value={dql} onChange={setDql} minLines={8} maxLines={16} />
        </SydLabel>
      </Grid>

      <Grid item xs={12}>
        {error ? <div style={{ color: 'red', marginBottom: '8px' }}>{error}</div> : null}
        <SydButton
          onClick={handleParse}
          processing={parsing}
          disabled={!dql.trim() || !purposeCode.trim() || !displayName.trim()}
          icon='play_arrow'
        >
          Parse Query
        </SydButton>
      </Grid>

      {parsedStructure && (
        <Grid item xs={12}>
          <div style={{
            padding: '12px',
            backgroundColor: '#e8f5e9',
            border: '1px solid #4caf50',
            borderRadius: '4px',
            color: '#2e7d32'
          }}
          >
            <strong>✓ Query parsed successfully</strong>
            <div style={{ marginTop: '4px', fontSize: '0.875rem' }}>
              {parsedStructure.purposeData?.tables?.length || 0} tables, {parsedStructure.purposeData?.columns?.length || 0} columns detected
            </div>
          </div>
        </Grid>
      )}

      <Grid item xs={12}>
        <SydModalActions>
          <SydButton disabled={parsing} variant='ghost' size='md' onClick={onCancel}>
            Cancel
          </SydButton>
          <SydButton
            disabled={!parsedStructure}
            variant='primary'
            size='md'
            onClick={handleAdd}
          >
            Add Purpose
          </SydButton>
        </SydModalActions>
      </Grid>
    </Grid>
  )
}

AddPurposeForm.propTypes = {
  onComplete: PropTypes.func,
  onCancel: PropTypes.func
}

export default AddPurposeForm
